import SegmentStore from '../../../../../../../SegmentStore';
import { FieldValue, SelectFormField } from '../../../../../Types';

interface Waiting {
  kind: 'waiting';
}

interface Initializing {
  kind: 'initializing';
  segmentStore: SegmentStore;
  formField: SelectFormField;
}

interface Ready {
  kind: 'ready';
  formField: SelectFormField;
  value: FieldValue[];
}

interface AutoSaving {
  kind: 'auto-saving';
  formField: SelectFormField;
  value: FieldValue[];
}

export type State = Waiting | Initializing | Ready | AutoSaving;

export const waiting = (): Waiting => ({
  kind: 'waiting',
});

export const initializing = (
  segmentStore: SegmentStore,
  formField: SelectFormField,
): Initializing => ({
  kind: 'initializing',
  segmentStore,
  formField,
});

export const ready = (formField: SelectFormField, value: FieldValue[]): Ready => ({
  kind: 'ready',
  formField,
  value,
});

export const autoSaving = (formField: SelectFormField, value: FieldValue[]): AutoSaving => ({
  kind: 'auto-saving',
  formField,
  value,
});
